import { Controller } from "@hotwired/stimulus"
import Handlebars from "handlebars"
import BaseGrid, { html } from "../utils/base_grid"

const statusBadgeTemplate = Handlebars.compile(`
  <span class="badge badge-{{statusClass}}">{{status}}</span>
`)

const typeBadgeTemplate = Handlebars.compile(`
  <span class="badge badge-{{typeClass}}">{{type}}</span>
`)

const actionsTemplate = Handlebars.compile(`
  {{#if downloadUrl}}
    <a href="{{downloadUrl}}" class="btn btn-sm btn-success">{{downloadLabel}}</a>
  {{else}}
    <span class="text-muted">—</span>
  {{/if}}
`)

export default class extends Controller {
  static values = { url: String, translations: Object }
  static targets = ["container", "skeleton"]

  connect() {
    const t = this.translationsValue || {}
    this.labels = {
      date: t.date || "Date",
      book: t.book || "Book",
      type: t.type || "Type",
      format: t.format || "Format",
      items: t.items || "Items",
      status: t.status || "Status",
      user: t.user || "User",
      actions: t.actions || "Actions",
      download: t.download || "Download",
      type_full: t.type_full || "Full",
      type_delta: t.type_delta || "Delta",
      status_pending: t.status_pending || "Pending",
      status_processing: t.status_processing || "Processing",
      status_completed: t.status_completed || "Completed",
      status_failed: t.status_failed || "Failed"
    }

    this.baseGrid = new BaseGrid(this, {
      limit: 10,
      columns: [
        { name: this.labels.date, id: "created_at" },
        { name: this.labels.book, id: "book_name" },
        { 
          name: this.labels.type, 
          id: "export_type",
          formatter: (cell) => {
            if (!cell) return ''
            const typeClass = cell === 'delta' ? 'warning' : 'info'
            const type = cell === 'delta' ? this.labels.type_delta : this.labels.type_full
            return html(typeBadgeTemplate({ type, typeClass }))
          }
        },
        { 
          name: this.labels.format, 
          id: "format",
          formatter: (cell) => cell ? cell.toUpperCase() : ''
        },
        { name: this.labels.items, id: "content_count" },
        { 
          name: this.labels.status, 
          id: "status",
          formatter: (cell) => {
            if (!cell) return ''
            let statusClass = 'secondary'
            let statusText = cell
            
            if (cell === 'completed') {
              statusClass = 'success'
              statusText = this.labels.status_completed
            } else if (cell === 'failed') {
              statusClass = 'danger'
              statusText = this.labels.status_failed
            } else if (cell === 'pending') {
              statusClass = 'warning'
              statusText = this.labels.status_pending
            } else if (cell === 'processing') {
              statusClass = 'info'
              statusText = this.labels.status_processing
            }
            
            return html(statusBadgeTemplate({ status: statusText, statusClass }))
          }
        },
        { name: this.labels.user, id: "user_email" },
        { 
          name: this.labels.actions, 
          sort: false,
          formatter: (cell, row) => {
             const downloadUrl = row.cells[8].data
             return html(actionsTemplate({ downloadUrl, downloadLabel: this.labels.download })) 
          }
        },
        { name: "DownloadURL", id: "download_url", hidden: true }
      ],
      mapData: (item) => [
        item.created_at, 
        item.book_name, 
        item.export_type, 
        item.format,
        item.content_count,
        item.status,
        item.user_email,
        null,
        item.download_url
      ]
    })
    
    this.grid = this.baseGrid.create()
  }

  disconnect() {
    this.baseGrid.destroy()
  }
}
